import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../store/AuthContext';
import { Spinner } from '../components/ui/index';

// ─── Protected Route ─────────────────────────────────────────────────
export function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === undefined) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}><Spinner size={32} /></div>;
  }
  if (!user) return <Navigate to="/" state={{ from: location }} replace />;
  return children;
}

// ─── Role Route ───────────────────────────────────────────────────────
export function RoleRoute({ allowed = [], children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/" replace />;
  if (allowed.length && !allowed.includes(user.type)) {
    return <Navigate to="/home" replace />;
  }
  return children;
}

export const ROUTES = {
  LOGIN: '/', SIGNUP: '/sign_up', REGISTER_PHONE: '/register_phone',
  FORGET_PASSWORD: '/forget_password', RESET_PASSWORD: '/reset_password',
  HOME: '/home', DASHBOARD: '/dashboard',
  NEW_TICKET: '/tickets/new', TICKET_LIST: '/tickets',
  TICKET_DETAIL: '/tickets/:id', TICKET_PROCESS: '/tickets/:id/process',
  DISPATCHER: '/dispatcher', DEPT_SELECTION: '/tickets/:id/assign',
  RESPONDED_TICKETS: '/tickets/responded', ON_PROCESS_TICKETS: '/tickets/in-progress',
  USER_LIST: '/users', ADD_COMPANY_USER: '/users/add/company',
  ADD_DEPT_EMPLOYEE: '/users/add/employee', PROFILE: '/profile', EDIT_PROFILE: '/profile/edit',
  COMPANY_LIST: '/companies', ADD_COMPANY: '/companies/add', ADD_DEPARTMENT: '/departments/add',
  MISSION_DEFINITION: '/missions/define', MISSION_RESPONSE: '/missions/:id/respond',
  DAILY_REPORT: '/reports/daily', MANAGER_REPORT: '/reports/manager',
  DISTANCE_REPORT: '/reports/distance', PRESENCE_REPORT: '/reports/presence',
  FEEDBACK: '/feedback', MY_FEEDBACK: '/feedback/mine', EMPLOYEE_FEEDBACK: '/feedback/team',
  AI_DASHBOARD: '/ai', AI_INSIGHTS: '/ai/insights',
  CURRENT_MAP: '/map', ADD_PLACE: '/map/add-place',
  SETTINGS: '/settings', SIGNATURE: '/settings/signature',
  MENU_ORDER: '/settings/menu', DAILY_REPORT_ITEMS: '/settings/daily-report-items',
};
